<template>
<div class="chapter">
<div class="inner_page">
<p class="p6"><span class="sz"><b>Acknowledgements</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p12"><span class="sz">I'd like to thank my talented editor, Alice Duncan, for being such a pleasure to work with, and <a href="http://www.ebookprep.com/" target="_blank"><span class="s2">eBook Prep</span></a> and <a href="http://www.epublishingworks.com/" target="_blank"><span class="s2">ePublishing Works</span></a> for their expertise and commitment to excellence.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section6.vue?3c632aea